<template >
 
 <beneficiaryCases v-if="[51].indexOf(this.getUserRoleId)>-1"/>
    
</template>



<script>
   // import petitions from "@/views/Petitions.vue"
    import beneficiaryCases from "@/views/beneficiaryCases.vue"

   export default {
        name:'caselist',
       components: {
            beneficiaryCases

        },
        mounted(){
            this.isRfe =false;
          // alert(this.$route.name);
           if(this.$route.name=='ref-cases'){
            this.isRfe =true;

           }
            
           
        },
        data: () => ({
            isRfe:false

        })

    }
</script>